import React from "react";
import { Link } from "react-router-dom";

export default function ResultModal(
  urlResult,
  point,
  resultData,
  setIsShowResult
) {
  const { examNo, examCount, pointExam, date, result } = resultData;
  console.log(resultData);
  return (
    <div className="container flex justify-center mx-auto">
      <div className="absolute inset-0 flex items-center justify-center bg-gray-700 bg-opacity-50">
        <div className="p-4 bg-white divide-y divide-gray-500 rounded-md w-[1000px] m-2">
          <div className="flex items-center justify-between">
            <h3 className="text-2xl">Kết quả thi mô phỏng</h3>
          </div>
          <div className="mt-4">
            <div className="flex flex-row justify-between">
              <div className="mr-4">
                <p>Đề đang thi: {examNo}</p>
                <p>Số tình huống: {examCount}</p>
                <p>Số điểm đạt: {pointExam}/50 điểm</p>
                <p>Ngày thi : {date}</p>
              </div>
              <div>
                <p>Kết quả :</p>
                <p>{result}</p>
              </div>
            </div>
            <table className="table-auto border-collapse border border-slate-400 w-full">
              <thead>
                <tr>
                  <th className="border border-slate-300">Câu hỏi</th>
                  {point?.map((item, i) => {
                    return <th class="border border-slate-300">{i + 1}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="border border-slate-300 font-bold text-center">
                    Điểm
                  </td>
                  {point?.map((item, i) => {
                    return <th class="border border-slate-300">{item}</th>;
                  })}
                </tr>
              </tbody>
            </table>
            <p>Link kết quả</p>
            <a href={urlResult} target="_blank" className="bg-yellow-500">
              {urlResult}
            </a>
            <div className="flex flex-row justify-end">
              <a
                href={"https://www.facebook.com/share.php?u=" + urlResult}
                className="my-2 p-2 mr-2 text-white bg-red-600"
              >
                Chia sẻ Facebook
              </a>
              <button
                onClick={() => setIsShowResult(false)}
                className="my-2 p-2 text-white bg-red-600"
              >
                Trở lại
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
